const ADMIN_TREND = 1;
const ADMIN = 2;
const ANALISTA = 3;
const ADMIN_SCANSOURCE = 4;
const GERENTE_MKT = 5;
const COORDENADOR_MKT = 6;
const CONTROLADORIA = 7;
const CRIATIVO = 8;
const DIRETOR = 9;

const PROFILES_ADMIN = [
  ADMIN,
  GERENTE_MKT,
  COORDENADOR_MKT,
  ADMIN_TREND,
  ADMIN_SCANSOURCE
]

export default {
  PROFILES_ADMIN,
  ANALISTA,
  CONTROLADORIA,
  CRIATIVO,
  DIRETOR
}